import { MessageBox } from "element-ui";
import utils from "@/utils/utils";

const messageBox = (options) => {
  options = {
    customClass: "my-el-message-box",
    ...options,
  };
  delete options.title
  messageBox.close = MessageBox.close
  return utils.messageBox(options);
};

const confirm = (message, title, options) => {
  options = {
    customClass: "my-el-message-box",
    ...options,
  };
  return MessageBox.confirm(message, title, options);
};

const alert = (message, title, options) => {
  options = {
    customClass: "my-el-message-box",
    ...options,
  };
  return MessageBox.alert(message, title, options);
};

export default {
  messageBox,
  confirm,
  alert,
};
